<template>
  <div class="form__field" style="width: 30em">
    <label class="form__label">Anrede</label>

    <div class="form__field__group">
      <div class="form__control">
        <input
          :checked="value === 'Frau'"
          @input="input"
          type="radio"
          name="salutation_frau"
          id="salutation_frau"
          value="Frau"
        />
        <label for="salutation_frau" class="form__switch">Frau</label>
      </div>
      <div class="form__control">
        <input
          :checked="value === 'Herr'"
          @input="input"
          type="radio"
          name="salutation_herr"
          id="salutation_herr"
          value="Herr"
        />
        <label for="salutation_herr" class="form__switch">Herr</label>
      </div>
    </div>

    <div
      class="form__message form__message--joined form__message--error"
      v-show="error"
    >
      Bitte Anrede wählen
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    error: Boolean
  },
  methods: {
    input(e) {
      this.$emit("input", e.target.value);
    }
  }
};
</script>
